import { Card, CardContent } from '@/components/ui/card';

export function MetricCard({ label, value, hint, icon: Icon, testid }) {
  return (
    <Card className="glass border-[var(--glass-border)] bg-[var(--glass)]">
      <CardContent className="flex items-start justify-between gap-4 p-5" data-testid={testid}>
        <div>
          <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</div>
          <div className="mt-2 font-mono text-2xl font-semibold tabular-nums">{value}</div>
          {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
        </div>
        {Icon && (
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[rgba(85,117,245,0.10)] text-[hsl(var(--primary))]">
            <Icon className="h-5 w-5" />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
